import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AuthService } from '../../shared/services/auth.service';
import { TPipe } from '../../shared/pipe/t.pipe';

@Component({
  selector: 'app-forbidden',
  imports: [RouterModule, TPipe],
  templateUrl: './forbidden.component.html',
})
export class ForbiddenComponent {
  private readonly auth = inject(AuthService);

  readonly user = this.auth.user;
  readonly roles = this.auth.roles;

  logout(): void {
    this.auth.logout();
  }
}
